<div class="grid-container">
  <div class="esf-accordion esf-accordion--info-tiles">
    <div app-accordion-table
         class="esf-accordion__unit esf-accordion--info-tiles"
         [isPanelOpened]="isPanelOpened"
         [accordionHeading]="tablesTranslations.i18nPriceReduction"
         [actionButtons]="actionButtons"
         [actionButtonIsDisabled]="!(selectedLottery.isDraftMode)"
         [emptyStateIcon]="'#esf-icon-dollar-check'"
         [emptyStateText]="tablesTranslations.i18nNoPriceReductions"
         (rowButtonClickEvent)="actionButtonClicked($event)"
         (rowClickEvent)="selectedLottery.isDraftMode ? editPriceReduction($event) : null"
         (panelTriggerClickEvent)="isPanelOpenedChange.emit(!isPanelOpened);"
         [data]="priceReductionsList"
         [keys]="keys"
         [columns]="columns">
    </div>
  </div>
</div>
